export const ADYEN_ENVS = {
  live: 'live',
  test: 'test',
} as const;

export type AdyenEnvs = (typeof ADYEN_ENVS)[keyof typeof ADYEN_ENVS];
